export default __webpack_public_path__ + "static/face_4-d7e47e43dce6ed856abc54434bb3e476.jpg";